import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UnifiedManifestState {
  list: any;
  loading: boolean;
  error: string | null;
}

const initialState: UnifiedManifestState = {
  list: null,
  loading: false,
  error: null,
};

const unifiedManifestSlice = createSlice({
  name: 'unifiedManifest',
  initialState,
  reducers: {
    setUnifiedManifestList(state, action: PayloadAction<any>) {
      state.list = action.payload;
      state.loading = false;
    },

    addUnifiedManifest(state: any, action: PayloadAction<any>) {
      const newManifest = action.payload;
      if (state.list && Array.isArray(state.list.manifests)) {
        state.list.manifests.unshift(newManifest);
        if (state.list.total !== undefined) state.list.total += 1;
      } else {
        state.list = { manifests: [newManifest], total: 1, totalPages: 1 };
      }
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const { setUnifiedManifestList, addUnifiedManifest, setLoading, setError } =
  unifiedManifestSlice.actions;

export default unifiedManifestSlice.reducer;
